<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2801 5.55507C10.2801 5.55507 9.62526 5.00644 8.85302 5.23829C8.14394 5.45119 8.04477 6.26606 8.55776 6.59938C8.55776 6.59938 9.06114 6.82319 9.61947 7.02846C10.9634 7.52253 10.3845 8.81844 9.30258 8.81844C8.76076 8.81844 8.30604 8.58197 8.03082 8.27927"
      stroke="#FFE400"
      stroke-width="1.09375"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.5993 5.18115L4.84705 8.76381C4.87319 8.83715 4.97751 8.83644 5.00267 8.76275L6.19425 5.1878"
      stroke="#FFE400"
      stroke-width="1.09375"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5419 10.3079C13.1206 9.3406 13.4531 8.20914 13.4531 7C13.4531 3.43604 10.564 0.546875 7 0.546875C3.43604 0.546875 0.546875 3.43604 0.546875 7C0.546875 10.564 3.43604 13.4531 7 13.4531C8.36486 13.4531 9.63077 13.0294 10.6733 12.3063"
      stroke="#FFE400"
      stroke-width="1.09375"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
export default {};
</script>
